/**
 * Toggles checked state of clicked checkbox
 * @param {HTMLInputElement} clickedCheckboxInput
 * @return {HTMLInputElement[]}
 */
export function toggleTermsFilterState(clickedCheckboxInput) {
    clickedCheckboxInput.checked = !clickedCheckboxInput.checked;
    return [clickedCheckboxInput];
}